





import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';
import {Inject} from 'inversify-props';

import {ISettingsService} from '@/services/settings/ISettings.service';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component
export default class GaugeChart extends Mixins<BaseComponent>(BaseComponent) {
  @Prop({default: 0})
  public value!: number;

  @Prop({default: ''})
  public label!: string;

  @Prop({default: ''})
  public unit!: string;

  @Prop({default: 0})
  public min!: number;

  @Prop({default: 100})
  public max!: number;

  @Inject(Symbol.for('ISettingsService'))
  private settingsService!: ISettingsService;

  get valuePercent() {
    return Math.round((this.value - this.min) * 100 / (this.max - this.min));
  }

  get options() {
    return {
      colors: [(options: any) => {
        if (options.value < 50) {
          return '#4CAF50';
        } else if (options.value < 80) {
          return '#FFC107';
        } else {
          return '#FF5252';
        }
      }],
      chart: {
        type: 'radialBar',
        sparkline: {
          enabled: true,
        },
      },
      plotOptions: {
        radialBar: {
          startAngle: -120,
          endAngle: 120,
          dataLabels: {
            show: true,
            name: {
              show: true,
              color: 'darkgray',
            },
            value: {
              color: 'black',
              fontSize: '1.5em',
              show: true,
              formatter: (v: number) => `${v} ${this.unit}`,
            },
          },
        },
      },
      stroke: {
        dashArray: 3,
      },
      labels: [this.label],
    };
  }
}
